import { useContext, Context } from 'react';
import _noop from 'lodash/noop';

export const emptyAnchorLinkContext = {
    activeScrollObservers: {},
    setActiveScrollObservers: _noop,
};

export const useAnchorLinksBase = (
    anchorLinkContext: Context<AnchorLinksProviderValue>,
): AnchorLinksProviderValue => {
    if (anchorLinkContext === null || anchorLinkContext === undefined) {
        return emptyAnchorLinkContext;
    }

    return useContext(anchorLinkContext);
};
